pnk-table {
  /* Component styles go here */
}

pnk-table pnk-select .arrow {
  padding: 0.5rem !important;
}
